import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var Bookmark = function Bookmark(props) {
  useDeprecatedComponentWarning({
    component: 'Bookmark'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 384 512"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
  }));
};

Bookmark.displayName = 'Bookmark';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Bookmark.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Bookmark;